<template>    
    <div class="container">
        <div class="card mt-3" style="align-items: center;">
            <div class="card-header" style="width: 100%;">
                <h4 class="mb-0 text-center">COTIZACIÓN LEASING OPERATIVO</h4>
                <b-button variant="dark" @click="back()">Volver </b-button>
            </div>

            <div v-if="isBusy" class="text-center text-danger space">
                <b-spinner class="align-middle"></b-spinner>
            </div>
            <template v-if="!isBusy">
                <!-- UN FOR DE ESTO -->
                <template>
                    <div class="card-body bordered" v-for="item in data" :key="item.id">     
                        <table class="table table-striped">
                            <tbody>                            
                                <tr>
                                    <th class="desc">MARCA</th>
                                    <td class="contenido">{{item.marca}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">MODELO</th>
                                    <td class="contenido">{{item.modelo}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">AÑO</th>
                                    <td class="contenido">{{item.año}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">CARACTERÍSTICAS</th>
                                    <td class="contenido">{{item.caracteristicas}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">EQUIPAMIENTO</th>
                                    <td class="contenido">{{item.equipamiento}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">CANTIDAD</th>
                                    <td class="contenido">{{item.cantidad}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">KILOMETRAJE</th>
                                    <td class="contenido">{{item.kilometraje}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">LUGAR DE ENTREGA</th>
                                    <td class="contenido">{{item.lugar_entrega}}</td>
                                </tr>
                            </tbody>
                        </table>

                        <b-table
                        :items="item.tabla"
                        :fields="fields"
                        responsive="sm"
                        :striped="true"
                        :bordered="true"
                        class="text-center"
                        >
                        </b-table>
                    </div>
                    
                </template>                
                <!-- FIN DEL FOR DE ESTO -->
            </template>            
        </div>
    </div>
</template>
<script>
import axios from "@/axios";
import moment from "moment";
export default {
    data() {
        return {
            data: [],
            isBusy: false,
            fields:[
            {
                key: "plazo",
                label: "Plazo (meses)",
                sortable: false,
                isRowHeader: true
            },
            {
                key: "valUniSinIVA",
                label: "Valor Unitario sin IVA",
                sortable: false,
            },
            {
                key: "flotaConectada",
                label: "Flota Conectada",
                sortable: false,
            },
            {
                key: "valUniConIva",
                label: "Valor unitario con IVA",
                sortable: false,
            }                
            ]
        };
    },
    beforeMount() {
        this.getDetail();
    },
    methods: {
        back() {
      history.back();
    },
        getDetail() {
            this.isBusy = true;
            axios
                .get(`DetalleCotizacion/${this.$store.getters["hideValue/detailId"]}`)
                .then((detalle) => {
                    this.isBusy = false;
                    this.data = detalle.data;
                })
                .catch(() => {
                    this.$bvToast.toast(
                        this.$t("lease.request.error.message").toString(),
                        {
                        title: this.$t("lease.request.error.nonFound").toString(),
                        variant: "danger",
                        solid: true,
                        }
                    );
                    this.isBusy = false;
                });
        },
        formatFecha(fecha){
            return moment(fecha).format("DD-MM-YYYY") + " " + moment(fecha).format("HH:mm:ss")
        }
    },
};
</script>

<style scoped>
.card-header:first-child{
    border-radius: 0.25rem;
}
.desc{
    width: 200px;
    text-align: left;
}
.bordered{
    border: solid 1px rgb(238, 111, 111);
    border-radius: 1rem;
    width: 70%;
    margin-top: 1rem;
    margin-bottom: 1rem;
}
</style>